module.exports = __webpack_public_path__ + "img/item6.bbdcfb79.png";